export const comparer = (originObject, diffObject, withNewFields = false) => {
    let diff = {};
    Object.keys(originObject).forEach((key)=>{
        if (diffObject.hasOwnProperty(key)) {
            if (originObject[key] !== null && typeof originObject[key] === 'object') {
                if (JSON.stringify(originObject[key]) !== JSON.stringify(diffObject[key])) {
                    diff[key] = diffObject[key];
                }
            } else {
                if (originObject[key] !== diffObject[key]) {
                    diff[key] = diffObject[key];
                }
            }
        }
    });
    if (withNewFields) {
        Object.keys(diffObject).forEach((key)=>{
            if (!originObject.hasOwnProperty(key)) {
                diff[key] = diffObject[key];
            }
        });
    }
    return diff;
};

export const copy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const validation = (originObj, validator) => {
    const badFields = [];

    Object.keys(validator).forEach((key)=>{

        if (originObj.hasOwnProperty(key)) {
            if (validator[key].validate && !validator[key].validate(originObj[key])) {
                badFields.push(key);
            } else if (validator[key].reg) {
                if (validator[key].reg === 'date') {
                    let validatorBool = (new RegExp(
                        '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])$',
                        "g"
                    )).test(originObj[key]);
                    if (!validatorBool) {
                        badFields.push(key);
                    }
                } else if (validator[key].reg === 'empty') {
                    if (originObj[key].length === 0) {
                        badFields.push(key);
                    }
                }
            }
        } else {
            badFields.push(key);
        }
    });
    return badFields;
};